// The email check used when inviting a family contact: stricter than "something@something.something"
// (no spaces or brackets, a dotted domain that ends in letters, or a bracketed IPv4 address).
// Shared by the family invite screens and the Neighbors Greetings invite.
// eslint-disable-next-line no-useless-escape
const EMAIL_PATTERN = /^(([^<>()\[\]\.,;:\s@"]+(\.[^<>()\[\]\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isValidEmailAddress = (email: string): boolean => EMAIL_PATTERN.test(email);
